const MIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="19"
    viewBox="0 0 25 19"
    fill="none"
  >
    <path
      d="M22.2141 2.17773L24.0874 0.393456V0H17.6063L12.9848 11.488L7.73118 0H0.934011V0.393456L3.11882 3.01955C3.33409 3.2117 3.44402 3.49993 3.41654 3.78359V14.1141C3.48524 14.4847 3.36157 14.869 3.10049 15.1389L0.636292 18.1173V18.5016H7.61667V18.1081L5.15247 15.1343C4.88681 14.8644 4.75856 14.4893 4.81353 14.1095V5.17898L10.942 18.5107H11.6565L16.9284 5.17898V15.7977C16.9284 16.0768 16.9284 16.1363 16.7452 16.3193L14.849 18.1493V18.5428H24.0462V18.1493L22.2187 16.3605C22.0584 16.2415 21.9759 16.0356 22.008 15.8389V2.69929C21.9759 2.50256 22.0538 2.30126 22.2141 2.17773Z"
      fill="white"
      fillOpacity="0.5"
    />
  </svg>
);

export default MIcon;
